module.exports = __webpack_public_path__ + "fonts/fa-regular-400.4a74738e.woff2";